export const GET_LIST_PREMIUM_ARTICLES_SECTIONS =
  "GET_LIST_PREMIUM_ARTICLES_SECTIONS";
export const GET_LIST_PREMIUM_ARTICLES_SECTIONS_SUCCESS =
  "GET_LIST_PREMIUM_ARTICLES_SECTIONS_SUCCESS";
export const GET_LIST_PREMIUM_ARTICLES_SECTIONS_ERROR =
  "GET_PREMIUM_ARTICLES_SECTIONS_ERROR";
